import axios from "axios";

const Base_Url="https://banglacalender.in/api/mutual_funds";




const getMutualFundData = async (authToken) => {
    try {

        const resMutualFundData = await axios({
            method: "get",
            url: `${Base_Url}`,
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        // console.log("Res Mutual Fund data: ", resMutualFundData.data);
        return resMutualFundData.data?.data||[];  
        
    } catch (error) {
      
        console.log("Error occurs when Fetching Mutual Fund data: ", error);

        throw error;

    }
}

export {getMutualFundData};